const getSortProps = ({
  querySort,
  sortProperties,
  defaultSort,
  querySortBy,
  defaultSortBy,
  isTextSearchFilterApplied
}) => {
  const updatedSortProperties = [...sortProperties];
  if (!querySort && !sortProperties.length && defaultSortBy && defaultSortBy.length) {
    updatedSortProperties.unshift({
      sort: defaultSort,
      propsToDisplay: defaultSortBy
    });
  }
  if (isTextSearchFilterApplied) updatedSortProperties.unshift({
    isScore: true
  });
  if (querySort) updatedSortProperties.unshift({
    sort: querySort,
    propsToDisplay: [querySortBy]
  });
  const sortbyFilters = updatedSortProperties.map(({
    propsToDisplay: filterProps
  }) => filterProps).filter(Boolean).flat();
  return {
    sortbyFilters,
    updatedSortProperties
  };
};
export default getSortProps;
//# sourceMappingURL=get-sort-props.js.map